const firstRun = {
  changeDocument: "変更",
  loadedDocuments: "{{count}} / {{total}}件のドキュメント",
  registeredOnly: "旧・新の登録文書2件または貼付テキスト2件、もしくは変化点資料1件を指定してください。文書とテキストの混在には未対応です。",
  pastedUnverified: "貼付テキスト由来／登録文書への紐付け未確認。候補として保存できますが、採用はできません。",
  chooseDocument: "登録文書を選択・変更",
  preview: "抽出本文を確認",
  documentCount: "検索結果 {{count}} 件",
  noDocuments: "該当する文書はありません。",
  registerDocument: "資料の登録は文書管理から",

  analysisInProgress: 'この分析は実行中です。完了を待ってから履歴で開き直してください。',
  rerunBlocked: '再分析するとレビュー・編集済みの行が失われるため開始できません。既存の結果を開いてレビューを続けてください。',
  sourceChanged: '分析後に出典文書が変更されました。現在の文書を選び直し、新しい分析を開始してください。',
  sourceVersionChanged: '選択した文書が分析開始前に更新されました。入力は保持されています。文書を選び直して現在の版を確認し、再試行してください。',
  sourcePreviewChanged: 'この文書は変更されています。現在の版を確認するため、文書を選び直してください。',
  sourceMissing: '出典文書が見つかりません。別の文書を選択して再試行してください。',
  sourceForbidden: '出典文書の閲覧権限がありません。閲覧できる文書を選び直してください。',
  sourcePending: '出典文書の本文を抽出中です。処理完了を待ってから再試行してください。',
  sourceFailed: '出典文書の本文抽出に失敗しました。文書を再処理するか別の文書を選択してください。',
  sourceUnsupported: 'この文書形式は分析に対応していません。対応するPDF・PowerPoint・Excel・Word文書を選択してください。',
  sourceEmpty: '出典文書の抽出本文が空です。文書を確認して別の文書を選択してください。',
  sourceTooLarge: '出典文書が分析の上限を超えています。文書を分割して小さい資料を選択してください。',
  analysisFailed: '分析に失敗しました。入力は保持されています。出典を確認して再試行してください。',
  supplementCopied: '生成された行に補足情報がコピーされたため停止しました。補足を確認して再試行してください。',
  streamInterrupted: '完了前に分析の接続が終了しました。再試行前に履歴からセッションの状態を確認してください。',
  initializationFailed: '分析は完了しましたがレビュー作業領域を開けませんでした。再分析せずに結果を開き直してください。',
  resultsLoadFailed: '分析は完了しましたが結果を取得できませんでした。再分析せずに結果を開き直してください。',
  returnToInput: '結果の復旧を終了して入力に戻る',
  retryResults: '結果を開き直す',
  noChanges: '分析が完了しました。変更点は見つかりませんでした。',
};
export default firstRun;
